import React from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { TestimonialsFirstSet, TestimonialsSecondSet } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { ComplexCases } from './components/ComplexCases';
import { CostComparison } from './components/CostComparison';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-dark-900 text-cream font-sans selection:bg-primary/30 selection:text-cream" data-id="element-0">
      <Hero data-id="element-1" />
      <StatsBar data-id="element-2" />
      <TestimonialsFirstSet data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductOverview data-id="element-5" />
      <Bonuses data-id="element-6" />
      <Pricing data-id="element-7" />
      <ComplexCases data-id="element-8" />
      <TestimonialsSecondSet data-id="element-9" />
      <CostComparison data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      {/* Final CTA is just a reuse of the Pricing section */}
      <div className="border-t-4 border-primary/20" data-id="element-13">
        <Pricing data-id="element-14" />
      </div>
      <Footer data-id="element-15" />
    </div>;
}